import toast from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';

import useUser from 'hooks/useUser';
import deleteUserImage from 'api/user/deleteUserImage';
import updateUserImage from 'api/user/updateUserImage';
import { checkImageFile } from 'utils/commonUtils';

const useUserImage = () => {
  const user = useUser();

  const updateMutation = useMutation({
    mutationFn: updateUserImage,
    onSuccess: () => user.refetch(),
    onError: () => toast.error('이미지 업로드에 실패했습니다.'),
  });

  const deleteMutation = useMutation({
    mutationFn: deleteUserImage,
    onSuccess: () => user.refetch(),
    onError: () => toast.error('이미지 삭제에 실패했습니다.'),
  });

  const handleFileChange = (event: React.FormEvent<HTMLInputElement>) => {
    const SIZE_2MB = 1024 ** 2 * 2; // 2MB;
    const { files } = event.currentTarget;
    const file = files![0];

    event.currentTarget.value = '';

    if (!checkImageFile(file, { maxSize: SIZE_2MB })) {
      toast.error('2MB이하의 이미지만 업로드 할 수 있습니다.');
      return;
    }

    updateMutation.mutate({ file });
  };

  const handleDeleteButtonClick = () => {
    deleteMutation.mutate();
  };

  return {
    userImageUrl: user.data?.userImageUrl,
    onFileChange: handleFileChange,
    onDeleteButtonClick: handleDeleteButtonClick,
  };
};

export default useUserImage;
